(function (global) {
  'use strict';
  var KEY = 'pkHimalayanPathResult:four12-v2';
  function clear() {
    try { global.sessionStorage.removeItem(KEY); } catch (_error) {}
  }
  function read() {
    try {
      var saved = JSON.parse(global.sessionStorage.getItem(KEY));
      var engine = global.PotalaKarmaFourPassages;
      if (!saved || !engine || saved.version !== engine.rules.version) return null;
      var result = engine.resolve(saved.answers);
      if (result.status !== 'result') { clear(); return null; }
      return { answers: saved.answers, resultId: result.resultId };
    } catch (_error) { return null; }
  }
  function save(answers) {
    try {
      var engine = global.PotalaKarmaFourPassages;
      if (!engine || engine.resolve(answers).status !== 'result') { clear(); return false; }
      var safe = {};
      Object.keys(engine.rules.options).forEach(function (key) { safe[key] = answers[key]; });
      global.sessionStorage.setItem(KEY, JSON.stringify({ version: engine.rules.version, answers: safe }));
      return true;
    } catch (_error) { return false; }
  }
  global.PKQuizResultState = { key: KEY, read: read, save: save, clear: clear };
  document.addEventListener('click', function (event) {
    var theme = global.Shopify && global.Shopify.theme;
    if (!theme || theme.role !== 'unpublished' || !event.target.closest) return;
    var link = event.target.closest('a[href]');
    if (!link || !link.closest('#PKReflection, #PKThemeShop, [data-pk-oracle-gateway]')) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '/' || href.slice(0, 2) === '//') return;
    var url = new global.URL(href, global.location.href);
    if (/^\/(cart|checkout)(\/|$)/.test(url.pathname)) return;
    url.searchParams.set('preview_theme_id', String(theme.id));
    link.href = url.pathname + url.search + url.hash;
  }, true);
  function initializeCultureReturn() {
    var saved = read();
    document.querySelectorAll('[data-quiz-return]').forEach(function (link) { link.hidden = !saved; });
    document.querySelectorAll('[data-quiz-retake]').forEach(function (link) {
      link.addEventListener('click', clear);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCultureReturn);
  else initializeCultureReturn();
  if (global.addEventListener) global.addEventListener('pageshow', initializeCultureReturn);
})(window);
